import { useState } from "react";
import { Link } from "react-router-dom";

export default function DonationSection() {
  const [showQR, setShowQR] = useState(false);

  const isMobile = () =>
    /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const handleDonateClick = (amount) => {
    const upiId = "yourupiid@okaxis"; // 🔴 REPLACE with real UPI ID
    const name = "Islamic Centre Trust";

    if (isMobile()) {
      const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(
        name
      )}&am=${amount}&cu=INR`;

      window.location.href = upiUrl;
    } else {
      setShowQR(true);

      // Auto close popup after 8 seconds
      setTimeout(() => {
        setShowQR(false);
      }, 4000);
    }
  };

  return (
    <>
      {/* Help Our Cause */}
      <div className='mt-12 sm:mt-16 md:mt-20 lg:mt-32 px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16'>
        <div className='max-w-7xl mx-auto'>
          <div className='flex flex-col lg:flex-row justify-between items-center gap-8 lg:gap-12 xl:gap-20'>
            
            <div className='flex justify-center w-full lg:w-1/2 order-2 lg:order-1'>
              <img
                className="object-cover w-full h-[400px] sm:h-[500px] md:h-[600px] max-w-sm sm:max-w-md lg:max-w-lg rounded-2xl shadow-2xl"
                src="images/landingzakat1.jpg"
                alt="Islamic Centre"
              />
            </div>  

            <div className='flex flex-col items-center w-full lg:w-1/2 order-1 lg:order-2'>
              <p className='font-black text-base sm:text-lg md:text-xl lg:text-2xl text-gray-600 uppercase tracking-wider'>
                HELP OUR MAIN CAUSE
              </p>

              <p className='font-black text-2xl sm:text-3xl md:text-4xl lg:text-5xl mt-2'>
                MAKE YOUR<br />DONATION
              </p>

              <img
                className="object-cover my-3 sm:my-4 md:my-6 w-[140px] sm:w-[160px] md:w-[180px] lg:w-[200px]"
                src="images/hrlineimg.png"
                alt="hrlineimg"
              />

              <h1 className='text-xl sm:text-2xl md:text-3xl lg:text-4xl font-black mt-2 text-center uppercase'>
                Education For Children
              </h1>

              <p className='text-justify max-w-xl text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl px-2 mt-3 sm:mt-4 font-light'>
                Support education, community welfare, and humanitarian causes. Your contribution helps provide essential services and improves lives in our community.
              </p>

              <div className='flex flex-wrap justify-center gap-2 sm:gap-3 lg:gap-4 mt-4 sm:mt-6'>
                <button
                  onClick={() => handleDonateClick(100)}
                  className='border-2 border-black py-2 px-4 sm:px-5 md:px-6 rounded-lg font-black text-xs sm:text-sm md:text-base hover:bg-gray-800 hover:text-white transition-all'
                >
                  100 ₹
                </button>

                <button
                  onClick={() => handleDonateClick(250)}
                  className='border-2 border-black py-2 px-4 sm:px-5 md:px-6 rounded-lg font-black text-xs sm:text-sm md:text-base hover:bg-gray-800 hover:text-white transition-all'
                >
                  250 ₹
                </button>

                <button
                  onClick={() => handleDonateClick(500)}
                  className='border-2 border-black py-2 px-4 sm:px-5 md:px-6 rounded-lg font-black text-xs sm:text-sm md:text-base hover:bg-gray-800 hover:text-white transition-all'
                >
                  500 ₹
                </button>

                <button
                  onClick={() => handleDonateClick(1000)}
                  className='border-2 border-black py-2 px-4 sm:px-5 md:px-6 rounded-lg font-black text-xs sm:text-sm md:text-base hover:bg-gray-800 hover:text-white transition-all'
                >
                  1000 ₹
                </button>
              </div>

              <div className='flex justify-center mt-3 sm:mt-10'>
                <Link to="/donate">
                  <button className='text-white bg-gray-800 hover:bg-gray-900 px-5 sm:px-6 md:px-8 py-2 md:py-3 w-36 sm:w-40 md:w-48 rounded-lg font-black text-xs sm:text-sm md:text-base transition-all hover:scale-105'>
                    DONATE NOW
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop QR Popup */}
      {showQR && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-2xl shadow-2xl max-w-sm w-full text-center">
            <h2 className="font-black text-xl mb-2">
              Scan to Donate
            </h2>

            <p className="text-sm text-gray-600 mb-4">
              Use Google Pay / PhonePe / Paytm
            </p>

            <img
              src="images/maekazqr.png" // 🔴 REPLACE with your QR image
              alt="Donate QR"
              className="mx-auto w-64 h-64"
            />

            <p className="text-xs text-gray-500 mt-3">
              This popup will close automatically
            </p>
          </div>
        </div>
      )}
    </>
  );
}
